import createIcon from '../../createIcon';

/**
 * @component @name AutoAwesome
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgOUwyMC4yNSA2LjI1TDIzIDVMMjAuMjUgMy43NUwxOSAxTDE3Ljc1IDMuNzVMMTUgNUwxNy43NSA2LjI1TDE5IDlaTTExLjUgOS41TDkgNEw2LjUgOS41TDEgMTJMNi41IDE0LjVMOSAyMEwxMS41IDE0LjVMMTcgMTJMMTEuNSA5LjVaTTE5IDE1TDE3Ljc1IDE3Ljc1TDE1IDE5TDE3Ljc1IDIwLjI1TDE5IDIzTDIwLjI1IDIwLjI1TDIzIDE5TDIwLjI1IDE3Ljc1TDE5IDE1WiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const AutoAwesome = createIcon('AutoAwesome', [
  [
    'path',
    {
      d: 'M19 9L20.25 6.25L23 5L20.25 3.75L19 1L17.75 3.75L15 5L17.75 6.25L19 9ZM11.5 9.5L9 4L6.5 9.5L1 12L6.5 14.5L9 20L11.5 14.5L17 12L11.5 9.5ZM19 15L17.75 17.75L15 19L17.75 20.25L19 23L20.25 20.25L23 19L20.25 17.75L19 15Z',
      key: '10yzou',
    },
  ],
]);

export default AutoAwesome;
